export default __webpack_public_path__ + "static/media/general-template2.5a6d1ffe.png";